"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCQACodeBenchV2Props = void 0;
var context_1 = require("../userContext/context");
/**
 * Parameterize this function as needed.
 */
function getCQACodeBenchV2Props(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.examDescription, examDescription = _c === void 0 ? "examDesc" : _c, _d = _b.cqaServiceLine, cqaServiceLine = _d === void 0 ? "serviceLine" : _d;
    return {
        UIView: "AMPLIFY",
        capabilities: {
            userContext: {
                organizationId: 0,
                organizationName: "",
                organizationCode: "",
                organizationType: "",
                tenantId: "",
                parentLevel: 1,
                healthSystemTenantId: "",
                healthSystemCode: "",
                healthSystemName: "",
                displayName: "",
                cognitoEnabled: false,
                resources: [],
                serviceLines: []
            },
            roles: ["cqa_coder", "cqa_manager"],
            holdCaseStatus: {
                hold_reason: "",
                comment: "",
                coding_manager_id: ""
            },
            cursorAPIContext: {
                sessionId: null,
                worklistContext: {
                    query: {
                        combinator: "AND",
                        filters: [
                            {
                                value: "IN_CQA",
                                key: "workitem.qa_status",
                                operation: "eq"
                            },
                            {
                                value: "CQA",
                                key: "workitem.case_type",
                                operation: "eq"
                            },
                            {
                                key: "workitem.qa_collection_id",
                                operation: "eq",
                                value: "db06bb42-be62-4cf5-b14b-957b0490acad"
                            },
                            {
                                value: "IN_CQA",
                                key: "workitem.qa_status",
                                operation: "eq"
                            }
                        ],
                        pagination: {
                            limit: 20,
                            offset: 0
                        },
                        groupByEncounter: false
                    },
                    resultSet: "d7718bc5-4cb8-51b1-b08a-a6c5eddd8746",
                    isQualityAssessment: true
                },
                servicedeskMode: true,
                workitemId: "f16d5763-67ec-47b5-8e83-462db8663774",
                qaCollectionUuid: "db06bb42-be62-4cf5-b14b-957b0490acad",
                launchConfigServiceLine: null
            },
            parentCaserunUid: null,
            parentCase: false,
            // @ts-ignore
            activeItem: {},
            capabilities: {
                noteUnavailableReason: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                coding: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                improvements: {
                    on: false
                },
                pagination: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                actionMenuCancelButton: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                submitCase: {
                    on: {
                        value: true,
                        reasons: []
                    },
                    actionable: {
                        value: true,
                        reasons: []
                    }
                },
                viewOnlyCase: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                holdCase: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                removeHoldCase: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                toggleCaseComment: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                toggleChargeableCase: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                caseEdit: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                actionMenu: {
                    on: false
                },
                generalCancelButton: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                improvementsAction: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                productivityTracker: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                oldCaseLoadedAlert: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                previousSentCaseAlert: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                servicedeskAction: {
                    on: {
                        value: true,
                        reasons: []
                    },
                    actionable: {
                        value: true,
                        reasons: []
                    }
                },
                mergeCapability: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                splitCapability: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                createCase: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                coderFeedback: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                timelineInfiniteLoad: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                attachDocs: {
                    on: false
                },
                diagnosisCodeSuggestion: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                coderNotes: {
                    on: false
                },
                transactionV2: {
                    on: {
                        value: false,
                        reasons: []
                    },
                    actionable: {
                        value: false,
                        reasons: []
                    }
                },
                versionProcess: {
                    on: false
                },
                statusDescription: {
                    on: false
                }
            }
        },
        displayCancellation: false,
        organization: null,
        prompt: null,
        activations: {
            panel: {},
            property: {},
            spans: {}
        },
        propertyConfig: {
            patient: [],
            summary: [
                {
                    key: "patient-dob",
                    label: "Age",
                    property: "date_of_birth",
                    transformer: "age",
                    dataSize: "ms"
                },
                {
                    key: "patient-gender",
                    label: "Gender",
                    property: "patient_gender",
                    dataSize: "ms"
                },
                {
                    key: "primary_insurance",
                    label: "Primary Insurance",
                    property: "primary_insurance",
                    dataSize: "l"
                },
                {
                    key: "hospital_account_record",
                    label: "Hospital Account Record",
                    property: "hospital_account_record",
                    dataSize: "l"
                },
                {
                    key: "patient_class",
                    label: "Patient Class",
                    property: "patient_class",
                    dataSize: "l"
                },
                {
                    key: "billing_location",
                    label: "Facility",
                    property: "billing_location",
                    dataSize: "l"
                },
                {
                    key: "service_line",
                    label: "Service Line",
                    property: "service_line",
                    transformer: "service_line",
                    dataSize: "l"
                },
                {
                    key: "visit_reason",
                    label: "Reason for Visit",
                    property: "visit_reason",
                    dataSize: "l"
                },
                {
                    key: "case_json_id",
                    label: "CMX Process ID",
                    property: "case_json_id",
                    dataSize: "ms"
                },
                {
                    key: "case_id",
                    label: "CMX Case ID",
                    property: "case_id",
                    dataSize: "l"
                },
                {
                    key: "specimen_sources",
                    label: "Primary Specimen Source",
                    transformer: "specimen_sources",
                    property: "specimen_sources",
                    dataSize: "m",
                    defaultHide: true
                },
                {
                    key: "exam_description",
                    label: "Exam Description",
                    property: "exam_description",
                    dataSize: "l"
                }
            ],
            expanded: []
        },
        modalURL: null,
        activeItem: {
            id: 393,
            import_id: "55decdf1-aa9a-4480-8706-1d794be36d09",
            rule_id: "1de1247d-8fbf-4059-8369-7ee481a94b87",
            rule_name: "Some Rule Name",
            rule_collection_id: "db06bb42-be62-4cf5-b14b-957b0490acad",
            matched_rule_criteria: "100%",
            matched_rule_value: "0.0%",
            service_line: cqaServiceLine,
            health_system_tenant_id: "df9b31e9-702e-4774-bd86-b6b3f4c7a7a9",
            health_system_code: null,
            insurance: "Mass General",
            case_category: "XRAY",
            date_of_birth: "1991-03-02",
            date_of_service: "2024-07-08",
            visit_reason: "lorem ipsum",
            exam_description: examDescription,
            patient_name: "Stark, Tony",
            patient_gender: "M",
            hospital_account_record: "123456789",
            patient_class: "Emergency",
            facility: "HFM",
            department: {
                code: "deptCode",
                name: "deptName"
            },
            referring_provider_name: "House, Gregory",
            performing_provider_name: "House, Gregory",
            billing_provider_name: "House, Gregory",
            notes: [],
            // @ts-ignore
            case_id: "5cd1eaba-9fca-439c-901b-c2b107464870",
            case_json_id: "BSP-12345678",
            tenant_uid: "df9b31e9-702e-4774-bd86-b6b3f4c7a7a9",
            process_instance_guid: null,
            case_run_uid: "caseRunUid",
            specimen_sources: [
                "Thyroid, Fine Needle Aspiration",
                "Ultrasound-guided fine needle aspiration"
            ],
            assigned_size: 1,
            processed_size: 1,
            flow: "IMPORT",
            status: "IN_CQA"
        },
        processInstance: null,
        codeDescriptions: {},
        codeEdits: {},
        counts: {
            procedures: 0,
            diagnosis: 0,
            modifiers: 0
        },
        hostCaseId: null,
        chargeSessions: [],
        preCommitChargeSessions: [],
        groupedCases: {
            groupType: "none",
            caseRuns: []
        },
        cases: [],
        activity: [],
        codableInvoices: [],
        nonCodeBench: false,
        userContext: (0, context_1.getContextState)(),
        benchEditable: {
            editable: true,
            waiting: false,
            submitted: false,
            cancelled: false,
            reason: ""
        },
        loadState: {
            loading: false,
            error: false,
            initial: false
        },
        artifactLoadState: {
            loading: true,
            error: false,
            initial: true
        },
        billingGroupLoadState: {
            loading: true,
            error: false,
            initial: false
        },
        relatedCasesLoadState: {
            loading: false,
            error: false,
            initial: false
        },
        refreshList: true,
        formErrors: {
            status: "",
            message: null,
            errors: [],
            fieldErrors: {}
        },
        // @ts-ignore
        artifactSet: {},
        artifactShowAll: false,
        searchResults: {},
        codeSearchResultsV2: {},
        invoiceOptions: {
            invoices: [],
            required_fields: [],
            summary: {
                departments: {},
                fee_schedules: {},
                all_departments: [],
                existing_departments: []
            }
        },
        notes: [
            {
                description: "",
                content: "lorem ipsum",
                filename: "Document",
                type: "Radiology",
                document_id: 123456,
                id: 123456,
                segments: [],
                spans: [],
                documentNotices: [],
                unique_document_number: "",
                filetype: "text/plain",
                benchmode: "GRADE"
            }
        ],
        artifactList: [],
        stages: [],
        displayTimeline: false,
        roles: ["cqa_coder", "cqa_manager"],
        caseRuns: {},
        displayAddCharge: false,
        showAddChargeError: false,
        showAddChargeLoading: false,
        showFeedBack: false,
        feedback: {
            id: null,
            message: "",
            dismissable: true
        },
        showSubmittedFeedback: false,
        showLoadingSubmission: false,
        showLoadingCancelation: false,
        showCanceledFeedback: false,
        submittedFeedbackTimer: false,
        showSizeExpWarning: false,
        showvitalwareIssuesModal: false,
        caseEdits: {},
        toggleHoldCaseModal: false,
        toggleCaseCommentModal: false,
        toggleExclusionCaseModal: false,
        toggleSplitCaseModal: false,
        submitOldCaseModal: false,
        vitalwareIssues: [],
        mergeSplitHistoryIssues: [],
        documentImprovementIssues: [],
        holdIssues: [],
        holdCaseStatus: {
            hold_reason: "",
            comment: "",
            coding_manager_id: ""
        },
        cursorAPIContext: {
            sessionId: null,
            worklistContext: {
                query: {
                    combinator: "AND",
                    filters: [
                        {
                            value: "IN_CQA",
                            key: "workitem.qa_status",
                            operation: "eq"
                        },
                        {
                            value: "CQA",
                            key: "workitem.case_type",
                            operation: "eq"
                        },
                        {
                            key: "workitem.qa_collection_id",
                            operation: "eq",
                            value: "db06bb42-be62-4cf5-b14b-957b0490acad"
                        },
                        {
                            value: "IN_CQA",
                            key: "workitem.qa_status",
                            operation: "eq"
                        }
                    ],
                    pagination: {
                        limit: 20,
                        offset: 0
                    },
                    groupByEncounter: false
                },
                resultSet: "d7718bc5-4cb8-51b1-b08a-a6c5eddd8746",
                isQualityAssessment: true
            },
            servicedeskMode: true,
            workitemId: "f16d5763-67ec-47b5-8e83-462db8663774",
            qaCollectionUuid: "db06bb42-be62-4cf5-b14b-957b0490acad",
            launchConfigServiceLine: null
        },
        entries: [],
        relatedCases: [],
        relatedCasesPageable: {
            pageableDefinition: {
                content: [],
                pageable: {
                    sort: {
                        sorted: false,
                        unsorted: true,
                        empty: true
                    },
                    offset: 0,
                    pageSize: 25,
                    pageNumber: 0,
                    unpaged: false,
                    paged: true
                },
                totalElements: 0,
                totalPages: 0,
                last: true,
                size: 0,
                number: 0,
                numberOfElements: 0,
                sort: {
                    sorted: false,
                    unsorted: true,
                    empty: true
                },
                first: true,
                empty: true
            },
            sortableOptions: [
                {
                    sortField: "dateOfService",
                    sortDirection: "desc"
                },
                {
                    sortField: "caseId",
                    sortDirection: "desc"
                }
            ],
            filterableOptions: {
                filters: []
            }
        },
        noteTypes: [],
        customClaimsRelatedCasesLoadState: {
            loading: false,
            error: false,
            initial: false
        },
        customClaimsRelatedCases: [],
        flagList: [],
        activeNote: {
            description: "",
            content: "lorem ipsum",
            filename: "Document",
            type: "Radiology",
            document_id: 123456,
            id: 123456,
            segments: [],
            spans: [],
            documentNotices: [],
            unique_document_number: "",
            filetype: "text/plain",
            benchmode: "GRADE"
        },
        caseAccessTime: "",
        activeMiniTab: "Charges",
        activeVerticalMiniTab: "Notes",
        showUnresolvedDocuments: false,
        benchMode: "GRADE",
        caseVersions: [],
        suggestedCodes: {
            cpt: {
                encounterList: [],
                caseList: []
            },
            modifier: {
                encounterList: [],
                caseList: []
            },
            diagnosis: {
                encounterList: [],
                caseList: []
            }
        },
        documentMetadata: [],
        contextParams: {
            caseId: null
        },
        epicToken: "",
        confirm: {
            title: "Remove Transaction",
            display: false
        },
        UIMode: "STANDALONE",
        improvements: {
            userContext: {
                organizationId: 0,
                organizationName: "",
                organizationCode: "",
                organizationType: "",
                tenantId: "",
                parentLevel: 1,
                healthSystemTenantId: "",
                healthSystemCode: "",
                healthSystemName: "",
                displayName: "",
                cognitoEnabled: false,
                resources: [],
                serviceLines: []
            },
            improvements: [],
            searchResults: [],
            providerSearchResults: [],
            procedureSearchResults: [],
            dictionaryValues: {
                numRows: 0,
                columnNames: [],
                rowValues: []
            }
        },
        caseRun: {},
        backToWorklistPath: "quality-assessment/",
        // "workItem": {},
        loadAlwaysFromURL: true,
        gradeableInvoices: [
            {
                id: 403,
                origInvoiceId: null,
                transactions: [
                    {
                        id: 553,
                        sequenceNumber: 1,
                        original: true,
                        diagnoses: [
                            {
                                id: 543,
                                codeAssessment: null,
                                original: true,
                                code: "R05.9",
                                sequenceNumber: 1,
                                description: "Cough, unspecified"
                            },
                            {
                                id: 544,
                                codeAssessment: null,
                                original: true,
                                code: "E00.9",
                                sequenceNumber: 2,
                                description: "Congenital iodine-deficiency syndrome, unspecified"
                            }
                        ],
                        modifiers: [],
                        procedures: [
                            {
                                id: 560,
                                codeAssessment: null,
                                original: true,
                                code: "99252",
                                sequenceNumber: 1,
                                units: 1,
                                description: "Initial inpatient consult, low level of complexity"
                            }
                        ]
                    }
                ],
                // @ts-ignore
                importId: "55decdf1-aa9a-4480-8706-1d794be36d09",
                ruleId: "1de1247d-8fbf-4059-8369-7ee481a94b87",
                ruleName: "Some Rule Name",
                ruleCollectionId: "db06bb42-be62-4cf5-b14b-957b0490acad",
                matchedRuleCriteria: "100%",
                matchedRuleValue: "0.0%",
                serviceLine: cqaServiceLine,
                healthSystemTenantId: "df9b31e9-702e-4774-bd86-b6b3f4c7a7a9",
                healthSystemCode: null,
                insurance: "Mass General",
                caseCategory: "XRAY",
                dateOfBirth: "1991-03-02",
                dateOfService: "2024-07-08",
                visitReason: "lorem ipsum",
                examDescription: examDescription,
                patientName: "Stark, Tony",
                patientGender: "M",
                hospitalAccountRecord: "123456789",
                patientClass: "Emergency",
                facility: "HFM",
                department: {
                    code: "deptCode",
                    name: "deptName"
                },
                referringProviderName: "House, Gregory",
                performingProviderName: "House, Gregory",
                billingProviderName: "House, Gregory",
                notes: [123456],
                caseId: "5cd1eaba-9fca-439c-901b-c2b107464870",
                caseJsonId: "BSP-12345678",
                tenantUid: "df9b31e9-702e-4774-bd86-b6b3f4c7a7a9",
                processInstanceGuid: null,
                caseRunUid: "caseRunUid",
                specimenSources: [
                    "Thyroid, Fine Needle Aspiration",
                    "Ultrasound-guided fine needle aspiration"
                ],
                assignedSize: 1,
                processedSize: 1,
                flow: "IMPORT",
                status: "IN_CQA"
            }
        ],
        fieldDefinitions: {
            icdFields: [
                {
                    key: "gripper",
                    path: [],
                    readonly: false,
                    width: "minmax(min-content, 10%)",
                    value: null,
                    svgIconName: "BiomeGripperSVG20",
                    svgIconSize: "20",
                    svgIconClass: "gripper",
                    classNames: ["units-column", "code-gripper", "gripper"],
                    fieldType: "icon"
                },
                {
                    codeType: "diagnosis",
                    key: "code",
                    path: ["code"],
                    readonly: false,
                    width: "minmax(min-content, 20%)",
                    fieldType: "code",
                    classNames: ["codes-column"]
                },
                {
                    key: "assessment",
                    path: ["codeAssessment", "assessment"],
                    readonly: false,
                    width: "1fr",
                    defaultOptions: [],
                    optionsPath: "assessmentOptions",
                    placeholder: "Select Assessment",
                    fieldType: "selectList",
                    rerenderFields: ["id", "code", "sequenceNumber"],
                    hidden: false,
                    options: [
                        "IDEAL ICD",
                        "INCORRECT SEQUENCING FOR NON-PRIMARY ICD",
                        "UNNECESSARY ICD",
                        "UNSPECIFIED ICD (MORE SPECIFIC CODE IS DOCUMENTED)",
                        "NON-PRIMARY ICD SHOULD BE PRIMARY",
                        "ICD GUIDELINE ERROR (EXCLUDES 1, CODE FIRST, ETC)",
                        "INVALID AS PRIMARY",
                        "INCIDENTAL FINDING AS PRIMARY",
                        "HISTORY OF VS CURRENT CANCER",
                        "WRONG SPECIFICITY OR LATERALITY",
                        "SIGN/SYMPTOM UNCERTAIN",
                        "SIGN/SYMPTOM NOT DOCUMENTED",
                        "OTHER DIAGNOSIS UNCERTAIN",
                        "OTHER DIAGNOSIS NOT DOCUMENTED",
                        "CANCER/AIDS/STDS UNCERTAIN",
                        "CANCER/AIDS/STDS NOT DOCUMENTED",
                        "PRIMARY ICD (CHIEF COMPLAINT, IMPRESSION, FINDING, ETC)",
                        "MEDICAL NECESSITY/ADDITIONAL DIAGNOSTIC FINDING (PATH DIAGNOSIS, RAD IMPRESSION)",
                        "INCIDENTAL FINDING",
                        "UNABLE TO EVALUATE"
                    ]
                },
                {
                    key: "role",
                    path: ["codeAssessment", "role"],
                    readonly: false,
                    width: "1fr",
                    defaultOptions: [],
                    optionsPath: "roleOptions",
                    placeholder: "Select Role",
                    fieldType: "selectList",
                    optionsTreePath: [["codeAssessment", "assessment"]],
                    rerenderFields: ["id", "code", "sequenceNumber"],
                    hidden: false,
                    options: [
                        "PRESENTING DIAGNOSIS",
                        "FINAL DIAGNOSIS",
                        "INCIDENTAL FINDINGS",
                        "HISTORY OF",
                        "STATUS",
                        "UNCERTAIN",
                        "SDoH",
                        "GUIDELINE VIOLATION",
                        "ERROR",
                        "N/A"
                    ],
                    optionsTree: {
                        "IDEAL ICD": [
                            "PRESENTING DIAGNOSIS",
                            "FINAL DIAGNOSIS",
                            "INCIDENTAL FINDINGS"
                        ],
                        "INCORRECT SEQUENCING FOR NON-PRIMARY ICD": [
                            "PRESENTING DIAGNOSIS",
                            "FINAL DIAGNOSIS",
                            "INCIDENTAL FINDINGS"
                        ],
                        "UNNECESSARY ICD": [
                            "PRESENTING DIAGNOSIS",
                            "INCIDENTAL FINDINGS",
                            "HISTORY OF",
                            "STATUS",
                            "UNCERTAIN",
                            "SDoH"
                        ],
                        "UNSPECIFIED ICD (MORE SPECIFIC CODE IS DOCUMENTED)": [
                            "PRESENTING DIAGNOSIS",
                            "FINAL DIAGNOSIS",
                            "INCIDENTAL FINDINGS"
                        ],
                        "NON-PRIMARY ICD SHOULD BE PRIMARY": [
                            "PRESENTING DIAGNOSIS",
                            "INCIDENTAL FINDINGS"
                        ],
                        "ICD GUIDELINE ERROR (EXCLUDES 1, CODE FIRST, ETC)": [
                            "GUIDELINE VIOLATION"
                        ],
                        "INVALID AS PRIMARY": ["GUIDELINE VIOLATION"],
                        "INCIDENTAL FINDING AS PRIMARY": ["INCIDENTAL FINDINGS"],
                        "HISTORY OF VS CURRENT CANCER": ["ERROR"],
                        "WRONG SPECIFICITY OR LATERALITY": ["ERROR"],
                        "SIGN/SYMPTOM UNCERTAIN": ["UNCERTAIN"],
                        "SIGN/SYMPTOM NOT DOCUMENTED": ["ERROR"],
                        "OTHER DIAGNOSIS UNCERTAIN": ["UNCERTAIN"],
                        "OTHER DIAGNOSIS NOT DOCUMENTED": ["ERROR"],
                        "CANCER/AIDS/STDS UNCERTAIN": ["UNCERTAIN"],
                        "CANCER/AIDS/STDS NOT DOCUMENTED": ["ERROR"],
                        "PRIMARY ICD (CHIEF COMPLAINT, IMPRESSION, FINDING, ETC)": [
                            "PRESENTING DIAGNOSIS",
                            "FINAL DIAGNOSIS"
                        ],
                        "MEDICAL NECESSITY/ADDITIONAL DIAGNOSTIC FINDING (PATH DIAGNOSIS, RAD IMPRESSION)": [
                            "PRESENTING DIAGNOSIS",
                            "FINAL DIAGNOSIS"
                        ],
                        "INCIDENTAL FINDING": ["INCIDENTAL FINDINGS"],
                        "UNABLE TO EVALUATE": ["N/A"]
                    }
                },
                {
                    key: "baseCQACodeAssessmentIcon",
                    path: [""],
                    readonly: false,
                    width: "0fr",
                    value: null,
                    svgIconName: "",
                    svgIconSize: "16",
                    svgIconClass: "",
                    classNames: ["assessment-icon-container"],
                    fieldType: "icon",
                    optionsTree: {}
                }
            ],
            modifierFields: [
                {
                    key: "gripper",
                    path: [],
                    readonly: false,
                    width: "minmax(min-content, 10%)",
                    value: null,
                    svgIconName: "BiomeGripperSVG20",
                    svgIconSize: "20",
                    svgIconClass: "gripper",
                    classNames: ["units-column", "code-gripper", "gripper"],
                    fieldType: "icon"
                },
                {
                    codeType: "modifier",
                    key: "code",
                    path: ["code"],
                    readonly: false,
                    width: "minmax(min-content, 20%)",
                    fieldType: "code",
                    classNames: ["codes-column"]
                },
                {
                    key: "assessment",
                    path: ["codeAssessment", "assessment"],
                    readonly: false,
                    width: "1fr",
                    defaultOptions: [],
                    optionsPath: "assessmentOptions",
                    placeholder: "Select Assessment",
                    fieldType: "selectList",
                    rerenderFields: ["id", "code", "sequenceNumber"],
                    optionsTreePath: [["code"], ["original"]],
                    hidden: false,
                    options: [
                        "IDEAL CPT",
                        "INCORRECT (FALSE POSITIVE)",
                        "MISSED (FALSE NEGATIVE)",
                        "UNABLE TO EVALUATE"
                    ],
                    optionsTree: {
                        "*": {
                            true: [
                                "IDEAL CPT",
                                "INCORRECT (FALSE POSITIVE)",
                                "UNABLE TO EVALUATE"
                            ],
                            false: ["MISSED (FALSE NEGATIVE)"]
                        }
                    }
                },
                {
                    key: "role",
                    path: ["codeAssessment", "role"],
                    readonly: false,
                    width: "1fr",
                    defaultOptions: [],
                    optionsPath: "roleOptions",
                    placeholder: "Select Role",
                    fieldType: "selectList",
                    optionsTreePath: [["code"], ["codeAssessment", "assessment"]],
                    rerenderFields: ["id", "code", "sequenceNumber"],
                    hidden: false,
                    options: ["N/A"],
                    optionsTree: {
                        "*": {
                            "IDEAL CPT": ["N/A"],
                            "INCORRECT (FALSE POSITIVE)": ["N/A"],
                            "MISSED (FALSE NEGATIVE)": ["N/A"],
                            "UNABLE TO EVALUATE": ["N/A"]
                        }
                    }
                },
                {
                    key: "baseCQACodeAssessmentIcon",
                    path: [""],
                    readonly: false,
                    width: "0fr",
                    value: null,
                    svgIconName: "",
                    svgIconSize: "16",
                    svgIconClass: "",
                    classNames: ["assessment-icon-container"],
                    fieldType: "icon",
                    optionsTree: {}
                }
            ],
            cptFields: [
                {
                    key: "units",
                    path: ["units"],
                    readonly: false,
                    width: "minmax(min-content, 10%)",
                    classNames: [
                        ["code-units-input"],
                        ["units-column", "code-units-populateable", "prevent-click"],
                        ["case-units-numeral"]
                    ],
                    displayName: null,
                    fieldType: "textInput",
                    validateInputString: "^\\d+$",
                    inputEnableRules: [
                        {
                            path: ["original"],
                            isNot: null
                        },
                        {
                            path: ["codeAssessment", "assessment"],
                            is: "ADDITIONAL UNIT OF CODED CPT"
                        }
                    ]
                },
                {
                    codeType: "procedure",
                    key: "code",
                    path: ["code"],
                    readonly: false,
                    width: "minmax(min-content, 20%)",
                    fieldType: "code",
                    classNames: ["codes-column"]
                },
                {
                    key: "assessment",
                    path: ["codeAssessment", "assessment"],
                    readonly: false,
                    width: "1fr",
                    defaultOptions: [],
                    optionsPath: "assessmentOptions",
                    placeholder: "Select Assessment",
                    fieldType: "selectList",
                    rerenderFields: ["id", "code", "sequenceNumber"],
                    hidden: false,
                    options: [
                        "IDEAL CPT",
                        "CPT IS NON-PAYABLE FOR FFS",
                        "CPT IS USED FOR TRACKING PURPOSES AND IS NOT CODABLE",
                        "UNBUNDLED (SEPARATE PROCEDURE, CCI EDIT, ETC.)",
                        "INVALID PRIMARY (E.G., ADD ON CODE)",
                        "MISSING OR INVALID ATTESTATION",
                        "SPLIT/SHARED SERVICE NON-BILLABLE PROVIDER",
                        "WRONG E/M CATEGORY OR CPT SPECIFICITY (INITIAL VS SUBSEQUENT, INPATIENT VS. CRITICAL CARE)(CORRECT CATEGORY)",
                        "INVALID CPT UNITS REPORTED",
                        "OVERCODED 1 E/M OR CPT LEVEL (E.G., 8830X)",
                        "UNDERCODED 1  E/M LEVEL OR CPT LEVEL",
                        "OVERCODED 2 E/M LEVELS OR CPT LEVEL",
                        "UNDERCODED 2 E/M LEVELS OR CPT LEVEL",
                        "NOT DOCUMENTED",
                        "CPT/EM CODE",
                        "ADDITIONAL UNIT OF CODED CPT",
                        "CORRECT E/M LEVEL OR CPT LEVEL (WRONG LEVEL CODED)",
                        "NON-PAYABLE CPT/EM CODE (POST-OP E/M)",
                        "TRACKING CPT/EM CODE",
                        "UNABLE TO EVALUATE"
                    ]
                },
                {
                    key: "role",
                    path: ["codeAssessment", "role"],
                    readonly: false,
                    width: "1fr",
                    defaultOptions: [],
                    optionsPath: "roleOptions",
                    placeholder: "Select Role",
                    fieldType: "selectList",
                    optionsTreePath: [["codeAssessment", "assessment"]],
                    rerenderFields: ["id", "code", "sequenceNumber"],
                    hidden: false,
                    options: [
                        "CODABLE",
                        "NON-PAYABLE",
                        "TRACKING",
                        "PERFORMED",
                        "ERROR",
                        "N/A"
                    ],
                    optionsTree: {
                        "IDEAL CPT": ["CODABLE"],
                        "CPT IS NON-PAYABLE FOR FFS": ["NON-PAYABLE"],
                        "CPT IS USED FOR TRACKING PURPOSES AND IS NOT CODABLE": [
                            "TRACKING"
                        ],
                        "UNBUNDLED (SEPARATE PROCEDURE, CCI EDIT, ETC.)": ["PERFORMED"],
                        "INVALID PRIMARY (E.G., ADD ON CODE)": ["CODABLE"],
                        "MISSING OR INVALID ATTESTATION": ["CODABLE"],
                        "SPLIT/SHARED SERVICE NON-BILLABLE PROVIDER": ["PERFORMED"],
                        "WRONG E/M CATEGORY OR CPT SPECIFICITY (INITIAL VS SUBSEQUENT, INPATIENT VS. CRITICAL CARE)(CORRECT CATEGORY)": [
                            "CODABLE"
                        ],
                        "INVALID CPT UNITS REPORTED": ["ERROR"],
                        "OVERCODED 1 E/M OR CPT LEVEL (E.G., 8830X)": ["ERROR"],
                        "UNDERCODED 1  E/M LEVEL OR CPT LEVEL": ["ERROR"],
                        "OVERCODED 2 E/M LEVELS OR CPT LEVEL": ["ERROR"],
                        "UNDERCODED 2 E/M LEVELS OR CPT LEVEL": ["ERROR"],
                        "NOT DOCUMENTED": ["ERROR"],
                        "CPT/EM CODE": ["CODABLE"],
                        "ADDITIONAL UNIT OF CODED CPT": ["CODABLE"],
                        "CORRECT E/M LEVEL OR CPT LEVEL (WRONG LEVEL CODED)": ["CODABLE"],
                        "NON-PAYABLE CPT/EM CODE (POST-OP E/M)": ["NON-PAYABLE"],
                        "TRACKING CPT/EM CODE": ["TRACKING"],
                        "UNABLE TO EVALUATE": ["N/A"]
                    }
                },
                {
                    key: "baseCQACodeAssessmentIcon",
                    path: [""],
                    readonly: false,
                    width: "0fr",
                    value: null,
                    svgIconName: "",
                    svgIconSize: "16",
                    svgIconClass: "",
                    classNames: ["assessment-icon-container"],
                    fieldType: "icon",
                    optionsTree: {}
                }
            ]
        },
        qaRuleCollection: {
            sampleReason: "Routine CQA - Onboarding",
            guideline: "2024",
            project_configuration: {
                role: true,
                modifier: true,
                diagnosis: true,
                procedure: true,
                assessment: true,
                caseEvaluationLevel: false
            }
        },
        riskCategories: {
            procedure: {
                "IDEAL CPT": [
                    // @ts-ignore
                    "CODABLE"
                ],
                "CPT IS NON-PAYABLE FOR FFS": [
                    // @ts-ignore
                    "NON-PAYABLE"
                ],
                "CPT IS USED FOR TRACKING PURPOSES AND IS NOT CODABLE": [
                    // @ts-ignore
                    "TRACKING"
                ],
                "UNBUNDLED (SEPARATE PROCEDURE, CCI EDIT, ETC.)": [
                    // @ts-ignore
                    "PERFORMED"
                ],
                "INVALID PRIMARY (E.G., ADD ON CODE)": [
                    // @ts-ignore
                    "CODABLE"
                ],
                "MISSING OR INVALID ATTESTATION": [
                    // @ts-ignore
                    "CODABLE"
                ],
                "SPLIT/SHARED SERVICE NON-BILLABLE PROVIDER": [
                    // @ts-ignore
                    "PERFORMED"
                ],
                "WRONG E/M CATEGORY OR CPT SPECIFICITY (INITIAL VS SUBSEQUENT, INPATIENT VS. CRITICAL CARE)(CORRECT CATEGORY)": [
                    // @ts-ignore
                    "CODABLE"
                ],
                "INVALID CPT UNITS REPORTED": [
                    // @ts-ignore
                    "ERROR"
                ],
                "OVERCODED 1 E/M OR CPT LEVEL (E.G., 8830X)": [
                    // @ts-ignore
                    "ERROR"
                ],
                "UNDERCODED 1  E/M LEVEL OR CPT LEVEL": [
                    // @ts-ignore
                    "ERROR"
                ],
                "OVERCODED 2 E/M LEVELS OR CPT LEVEL": [
                    // @ts-ignore
                    "ERROR"
                ],
                "UNDERCODED 2 E/M LEVELS OR CPT LEVEL": [
                    // @ts-ignore
                    "ERROR"
                ],
                "NOT DOCUMENTED": [
                    // @ts-ignore
                    "ERROR"
                ],
                "CPT/EM CODE": [
                    // @ts-ignore
                    "CODABLE"
                ],
                "ADDITIONAL UNIT OF CODED CPT": [
                    // @ts-ignore
                    "CODABLE"
                ],
                "CORRECT E/M LEVEL OR CPT LEVEL (WRONG LEVEL CODED)": [
                    // @ts-ignore
                    "CODABLE"
                ],
                "NON-PAYABLE CPT/EM CODE (POST-OP E/M)": [
                    // @ts-ignore
                    "NON-PAYABLE"
                ],
                "TRACKING CPT/EM CODE": [
                    // @ts-ignore
                    "TRACKING"
                ],
                "UNABLE TO EVALUATE": [
                    // @ts-ignore
                    "N/A"
                ]
            },
            diagnosis: {
                "IDEAL ICD": [
                    // @ts-ignore
                    "PRESENTING DIAGNOSIS",
                    // @ts-ignore
                    "FINAL DIAGNOSIS",
                    // @ts-ignore
                    "INCIDENTAL FINDINGS"
                ],
                "INCORRECT SEQUENCING FOR NON-PRIMARY ICD": [
                    // @ts-ignore
                    "PRESENTING DIAGNOSIS",
                    // @ts-ignore
                    "FINAL DIAGNOSIS",
                    // @ts-ignore
                    "INCIDENTAL FINDINGS"
                ],
                "UNNECESSARY ICD": [
                    // @ts-ignore
                    "PRESENTING DIAGNOSIS",
                    // @ts-ignore
                    "INCIDENTAL FINDINGS",
                    // @ts-ignore
                    "HISTORY OF",
                    // @ts-ignore
                    "STATUS",
                    // @ts-ignore
                    "UNCERTAIN",
                    // @ts-ignore
                    "SDoH"
                ],
                "UNSPECIFIED ICD (MORE SPECIFIC CODE IS DOCUMENTED)": [
                    // @ts-ignore
                    "PRESENTING DIAGNOSIS",
                    // @ts-ignore
                    "FINAL DIAGNOSIS",
                    // @ts-ignore
                    "INCIDENTAL FINDINGS"
                ],
                "NON-PRIMARY ICD SHOULD BE PRIMARY": [
                    // @ts-ignore
                    "PRESENTING DIAGNOSIS",
                    // @ts-ignore
                    "INCIDENTAL FINDINGS"
                ],
                "ICD GUIDELINE ERROR (EXCLUDES 1, CODE FIRST, ETC)": [
                    // @ts-ignore
                    "GUIDELINE VIOLATION"
                ],
                "INVALID AS PRIMARY": [
                    // @ts-ignore
                    "GUIDELINE VIOLATION"
                ],
                "INCIDENTAL FINDING AS PRIMARY": [
                    // @ts-ignore
                    "INCIDENTAL FINDINGS"
                ],
                "HISTORY OF VS CURRENT CANCER": [
                    // @ts-ignore
                    "ERROR"
                ],
                "WRONG SPECIFICITY OR LATERALITY": [
                    // @ts-ignore
                    "ERROR"
                ],
                "SIGN/SYMPTOM UNCERTAIN": [
                    // @ts-ignore
                    "UNCERTAIN"
                ],
                "SIGN/SYMPTOM NOT DOCUMENTED": [
                    // @ts-ignore
                    "ERROR"
                ],
                "OTHER DIAGNOSIS UNCERTAIN": [
                    // @ts-ignore
                    "UNCERTAIN"
                ],
                "OTHER DIAGNOSIS NOT DOCUMENTED": [
                    // @ts-ignore
                    "ERROR"
                ],
                "CANCER/AIDS/STDS UNCERTAIN": [
                    // @ts-ignore
                    "UNCERTAIN"
                ],
                "CANCER/AIDS/STDS NOT DOCUMENTED": [
                    // @ts-ignore
                    "ERROR"
                ],
                "PRIMARY ICD (CHIEF COMPLAINT, IMPRESSION, FINDING, ETC)": [
                    // @ts-ignore
                    "PRESENTING DIAGNOSIS",
                    // @ts-ignore
                    "FINAL DIAGNOSIS"
                ],
                "MEDICAL NECESSITY/ADDITIONAL DIAGNOSTIC FINDING (PATH DIAGNOSIS, RAD IMPRESSION)": [
                    // @ts-ignore
                    "PRESENTING DIAGNOSIS",
                    // @ts-ignore
                    "FINAL DIAGNOSIS"
                ],
                "INCIDENTAL FINDING": [
                    // @ts-ignore
                    "INCIDENTAL FINDINGS"
                ],
                "UNABLE TO EVALUATE": [
                    // @ts-ignore
                    "N/A"
                ]
            },
            modifier: {
                "*": {
                    // @ts-ignore
                    "IDEAL CPT": ["N/A"],
                    "INCORRECT (FALSE POSITIVE)": ["N/A"],
                    "MISSED (FALSE NEGATIVE)": ["N/A"],
                    "UNABLE TO EVALUATE": ["N/A"]
                }
            }
        },
        cqaCodeAssessmentRiskDictionaries: {
            procedure: {
                columnNames: [
                    "ASSESSMENT",
                    "Key",
                    "ACCEPTABILITY\nBY STAR USE CASE",
                    "CATEGORY",
                    "ROLE"
                ],
                rows: [
                    {
                        assessment: "IDEAL CPT",
                        category: "CORRECT",
                        role: "CODABLE"
                    },
                    {
                        assessment: "CPT IS NON-PAYABLE FOR FFS",
                        category: "INCORRECT",
                        role: "NON-PAYABLE"
                    },
                    {
                        assessment: "CPT IS USED FOR TRACKING PURPOSES AND IS NOT CODABLE",
                        category: "INCORRECT",
                        role: "TRACKING"
                    },
                    {
                        assessment: "UNBUNDLED (SEPARATE PROCEDURE, CCI EDIT, ETC.)",
                        category: "INCORRECT",
                        role: "PERFORMED"
                    },
                    {
                        assessment: "INVALID PRIMARY (E.G., ADD ON CODE)",
                        category: "INCORRECT",
                        role: "CODABLE"
                    },
                    {
                        assessment: "MISSING OR INVALID ATTESTATION",
                        category: "INCORRECT",
                        role: "CODABLE"
                    },
                    {
                        assessment: "SPLIT/SHARED SERVICE NON-BILLABLE PROVIDER",
                        category: "INCORRECT",
                        role: "PERFORMED"
                    },
                    {
                        assessment: "WRONG E/M CATEGORY OR CPT SPECIFICITY (INITIAL VS SUBSEQUENT, INPATIENT VS. CRITICAL CARE)(CORRECT CATEGORY)",
                        category: "INCORRECT",
                        role: "CODABLE"
                    },
                    {
                        assessment: "INVALID CPT UNITS REPORTED",
                        category: "INCORRECT",
                        role: "ERROR"
                    },
                    {
                        assessment: "OVERCODED 1 E/M OR CPT LEVEL (E.G., 8830X)",
                        category: "INCORRECT",
                        role: "ERROR"
                    },
                    {
                        assessment: "UNDERCODED 1  E/M LEVEL OR CPT LEVEL",
                        category: "INCORRECT",
                        role: "ERROR"
                    },
                    {
                        assessment: "OVERCODED 2 E/M LEVELS OR CPT LEVEL",
                        category: "INCORRECT",
                        role: "ERROR"
                    },
                    {
                        assessment: "UNDERCODED 2 E/M LEVELS OR CPT LEVEL",
                        category: "INCORRECT",
                        role: "ERROR"
                    },
                    {
                        assessment: "NOT DOCUMENTED",
                        category: "INCORRECT",
                        role: "ERROR"
                    },
                    {
                        assessment: "CPT/EM CODE",
                        category: "MISSED",
                        role: "CODABLE"
                    },
                    {
                        assessment: "ADDITIONAL UNIT OF CODED CPT",
                        category: "MISSED",
                        role: "CODABLE"
                    },
                    {
                        assessment: "CORRECT E/M LEVEL OR CPT LEVEL (WRONG LEVEL CODED)",
                        category: "MISSED",
                        role: "CODABLE"
                    },
                    {
                        assessment: "NON-PAYABLE CPT/EM CODE (POST-OP E/M)",
                        category: "MISSED",
                        role: "NON-PAYABLE"
                    },
                    {
                        assessment: "TRACKING CPT/EM CODE",
                        category: "MISSED",
                        role: "TRACKING"
                    },
                    {
                        assessment: "UNABLE TO EVALUATE",
                        category: "N/A",
                        role: "N/A"
                    }
                ]
            },
            diagnosis: {
                columnNames: [
                    "ACCEPTABILITY BY STAR USE CASE",
                    "CATEGORY",
                    "ROLE",
                    "ASSESSMENT",
                    "Key"
                ],
                rows: [
                    {
                        assessment: "IDEAL ICD",
                        category: "CORRECT",
                        role: "PRESENTING DIAGNOSIS"
                    },
                    {
                        assessment: "IDEAL ICD",
                        category: "CORRECT",
                        role: "FINAL DIAGNOSIS"
                    },
                    {
                        assessment: "IDEAL ICD",
                        category: "CORRECT",
                        role: "INCIDENTAL FINDINGS"
                    },
                    {
                        assessment: "INCORRECT SEQUENCING FOR NON-PRIMARY ICD",
                        category: "INCORRECT",
                        role: "PRESENTING DIAGNOSIS"
                    },
                    {
                        assessment: "INCORRECT SEQUENCING FOR NON-PRIMARY ICD",
                        category: "INCORRECT",
                        role: "FINAL DIAGNOSIS"
                    },
                    {
                        assessment: "INCORRECT SEQUENCING FOR NON-PRIMARY ICD",
                        category: "INCORRECT",
                        role: "INCIDENTAL FINDINGS"
                    },
                    {
                        assessment: "UNNECESSARY ICD",
                        category: "INCORRECT",
                        role: "PRESENTING DIAGNOSIS"
                    },
                    {
                        assessment: "UNNECESSARY ICD",
                        category: "INCORRECT",
                        role: "INCIDENTAL FINDINGS"
                    },
                    {
                        assessment: "UNNECESSARY ICD",
                        category: "INCORRECT",
                        role: "HISTORY OF"
                    },
                    {
                        assessment: "UNNECESSARY ICD",
                        category: "INCORRECT",
                        role: "STATUS"
                    },
                    {
                        assessment: "UNNECESSARY ICD",
                        category: "INCORRECT",
                        role: "UNCERTAIN"
                    },
                    {
                        assessment: "UNNECESSARY ICD",
                        category: "INCORRECT",
                        role: "SDoH"
                    },
                    {
                        assessment: "UNSPECIFIED ICD (MORE SPECIFIC CODE IS DOCUMENTED)",
                        category: "INCORRECT",
                        role: "PRESENTING DIAGNOSIS"
                    },
                    {
                        assessment: "UNSPECIFIED ICD (MORE SPECIFIC CODE IS DOCUMENTED)",
                        category: "INCORRECT",
                        role: "FINAL DIAGNOSIS"
                    },
                    {
                        assessment: "UNSPECIFIED ICD (MORE SPECIFIC CODE IS DOCUMENTED)",
                        category: "INCORRECT",
                        role: "INCIDENTAL FINDINGS"
                    },
                    {
                        assessment: "NON-PRIMARY ICD SHOULD BE PRIMARY",
                        category: "INCORRECT",
                        role: "PRESENTING DIAGNOSIS"
                    },
                    {
                        assessment: "NON-PRIMARY ICD SHOULD BE PRIMARY",
                        category: "INCORRECT",
                        role: "INCIDENTAL FINDINGS"
                    },
                    {
                        assessment: "ICD GUIDELINE ERROR (EXCLUDES 1, CODE FIRST, ETC)",
                        category: "INCORRECT",
                        role: "GUIDELINE VIOLATION"
                    },
                    {
                        assessment: "INVALID AS PRIMARY",
                        category: "INCORRECT",
                        role: "GUIDELINE VIOLATION"
                    },
                    {
                        assessment: "INCIDENTAL FINDING AS PRIMARY",
                        category: "INCORRECT",
                        role: "INCIDENTAL FINDINGS"
                    },
                    {
                        assessment: "HISTORY OF VS CURRENT CANCER",
                        category: "INCORRECT",
                        role: "ERROR"
                    },
                    {
                        assessment: "WRONG SPECIFICITY OR LATERALITY",
                        category: "INCORRECT",
                        role: "ERROR"
                    },
                    {
                        assessment: "SIGN/SYMPTOM UNCERTAIN",
                        category: "INCORRECT",
                        role: "UNCERTAIN"
                    },
                    {
                        assessment: "SIGN/SYMPTOM NOT DOCUMENTED",
                        category: "INCORRECT",
                        role: "ERROR"
                    },
                    {
                        assessment: "OTHER DIAGNOSIS UNCERTAIN",
                        category: "INCORRECT",
                        role: "UNCERTAIN"
                    },
                    {
                        assessment: "OTHER DIAGNOSIS NOT DOCUMENTED",
                        category: "INCORRECT",
                        role: "ERROR"
                    },
                    {
                        assessment: "CANCER/AIDS/STDS UNCERTAIN",
                        category: "INCORRECT",
                        role: "UNCERTAIN"
                    },
                    {
                        assessment: "CANCER/AIDS/STDS NOT DOCUMENTED",
                        category: "INCORRECT",
                        role: "ERROR"
                    },
                    {
                        assessment: "PRIMARY ICD (CHIEF COMPLAINT, IMPRESSION, FINDING, ETC)",
                        category: "MISSED",
                        role: "PRESENTING DIAGNOSIS"
                    },
                    {
                        assessment: "PRIMARY ICD (CHIEF COMPLAINT, IMPRESSION, FINDING, ETC)",
                        category: "MISSED",
                        role: "FINAL DIAGNOSIS"
                    },
                    {
                        assessment: "MEDICAL NECESSITY/ADDITIONAL DIAGNOSTIC FINDING (PATH DIAGNOSIS, RAD IMPRESSION)",
                        category: "MISSED",
                        role: "PRESENTING DIAGNOSIS"
                    },
                    {
                        assessment: "MEDICAL NECESSITY/ADDITIONAL DIAGNOSTIC FINDING (PATH DIAGNOSIS, RAD IMPRESSION)",
                        category: "MISSED",
                        role: "FINAL DIAGNOSIS"
                    },
                    {
                        assessment: "INCIDENTAL FINDING",
                        category: "MISSED",
                        role: "INCIDENTAL FINDINGS"
                    },
                    {
                        assessment: "UNABLE TO EVALUATE",
                        category: "N/A",
                        role: "N/A"
                    }
                ]
            },
            modifier: {
                columnNames: [
                    "MODIFIER",
                    "DESCRIPTION",
                    "ROLE",
                    "Key",
                    "CATEGORY",
                    "ASSESSMENT"
                ],
                rows: [
                    {
                        assessment: "IDEAL CPT",
                        category: "CORRECT",
                        role: "N/A",
                        description: "INCREASED PROCEDURAL SERVICE",
                        modifier: "*"
                    },
                    {
                        assessment: "INCORRECT (FALSE POSITIVE)",
                        category: "INCORRECT",
                        role: "N/A",
                        description: "INCREASED PROCEDURAL SERVICE",
                        modifier: "*"
                    },
                    {
                        assessment: "MISSED (FALSE NEGATIVE)",
                        category: "MISSED",
                        role: "N/A",
                        description: "INCREASED PROCEDURAL SERVICE",
                        modifier: "*"
                    },
                    {
                        assessment: "UNABLE TO EVALUATE",
                        category: "N/A",
                        role: "N/A",
                        description: "N/A",
                        modifier: "*"
                    }
                ]
            }
        },
        gradingErrors: {
            addTransaction: false
        },
        submitButtonConfig: {
            enabled: false,
            text: "Save",
            tooltip: "Submit your work and move to next task"
        },
        match: {
            path: "/cmx/quality-assessment/workItem/:id/",
            url: "/cmx/quality-assessment/workItem/f16d5763-67ec-47b5-8e83-462db8663774",
            isExact: true,
            params: {
                id: "f16d5763-67ec-47b5-8e83-462db8663774"
            }
        },
        processInstanceGuids: []
    };
}
exports.getCQACodeBenchV2Props = getCQACodeBenchV2Props;
//# sourceMappingURL=CQACodeBenchV2Props.js.map